<template>
  <div>
    <div v-if="$auth.policies['student-register-list']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Danh sách đăng ký"
            :link="[
              {
                text: 'Danh sách đăng ký',
                href: '../student-menu-register'
              }
            ]"
          />
        </div>
        <div class="d-flex" style="gap: 8px">
          <v-btn
            v-if="$vuetify.breakpoint.mdAndUp"
            outlined
            color="primary"
            :disabled="loading || !$_get(studentMenuSearchParams, 'date') || !$_get(selectedSlot, 'id')"
            @click="$refs.importDialog.openDialog()"
          >
            <v-icon left>mdi-file-upload-outline</v-icon> Nhập Excel
          </v-btn>
          <v-btn
            v-if="$vuetify.breakpoint.mdAndUp"
            outlined
            color="success"
            :disabled="loading || !$_get(studentMenuSearchParams, 'date')"
            @click="exportExcel"
          >
            <v-icon left>mdi-file-excel</v-icon> Xuất Excel
          </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <StudentMenuRegisterFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <StudentMenuRegisterTable ref="table" />
      </v-card>

      <ImportRegisterDialog
        ref="importDialog"
        :date="$_get(studentMenuSearchParams, 'date')"
        :meal-slot="$_get(selectedSlot, 'id')"
        :slot-title="$_get(selectedSlot, 'title')"
        @imported="onImported"
      />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import utils from '@/plugins/utils'
import { StudentMenu } from '@/plugins/api'
import StudentMenuRegisterTable from '@/modules/studentMenuRegister/StudentMenuRegisterTable.vue'
import StudentMenuRegisterFilter from '@/modules/studentMenuRegister/StudentMenuRegisterFilter.vue'
import ImportRegisterDialog from '@/modules/studentMenuRegister/ImportRegisterDialog.vue'

export default {
  components: {
    Breadcrumbs,
    StudentMenuRegisterTable,
    StudentMenuRegisterFilter,
    ImportRegisterDialog
  },
  props: {},
  data() {
    return {
      newDialog: false,
      type: ''
    }
  },
  computed: {
    ...mapState('StudentMenuRegister', ['studentMenuSearchParams', 'date', 'selectedSlot', 'loading'])
  },
  methods: {
    ...mapActions('StudentMenuRegister', ['setDate']),

    async refresh(query) {
      this.$refs.table.refresh(query)
    },
    onFilterChange(query) {
      if (get(query, 'date')) this.setDate(query.date)
      this.refresh(query)
    },

    onImported() {
      this.$refs.table.reloadCurrentPage()
    },

    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })

        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'actions')
        const filters = this.$options.filters
        // Xuất Excel cần TẤT CẢ bản ghi (không phân trang) -> _limit: -1; API trả { data, total }.
        const res = await StudentMenu.getMenuRegisterByStudents({ ...this.studentMenuSearchParams, _limit: -1 })
        const list = res.data || []
        const studentMenus = JSON.parse(JSON.stringify(list))
        const data = studentMenus.map(item => {
          item.mealTransferStatus = filters.mealTransferStatus(item.mealTransferStatus)
          item.selectedMenu = filters.selectedMenu(get(item, 'studentMenu.selectedMenu'))
          if (get(item, 'studentMenu.selectedMenu')) item.registedAmount = get(item, 'studentMenu.amount', 1)
          item.realAteAmount = get(item, 'mealTransfer.amount', 0)
          item.mealSlot =
            get(item, 'mealSlotTitle') || get(item, 'studentMenu.mealSlotTitle') || get(this.selectedSlot, 'title') || ''
          item.code = filters.getStudentCode(item.student.code)
          item.dob = filters.ddmmyyyy(item.student.dob)
          item.class = get(item, 'student.currentClass.title')
          item.student = item.student.name
          return item
        })
        const date = filters.ddmmyyyy(this.date).replaceAll('/', '-')
        utils.exportExcel(data, excelHeader, `${date}_DSDangKySuatAn`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  created() {
    //
  }
}
</script>
<style scoped></style>
